import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import apiClient from "../../apiClient";
import { SSO_URL, UNO_APPLICATION_ID } from "../../env";
import { GET_CHANNEL_APPLICATIONS, GET_CHANNEL_DETAILS } from "../../apiClient/apiEndpoints";
import SearchBox from "../common/SearchBox";
import { BackButton, PlusIcon } from "../../assets/Icons";
import ChannelDetails from "../../pages/ChannelDetails";
import AddDirectoryApplication from "../../Modals/AddDirectoryApplication";
import NoDataFound from "../common/NoDataFound";

const ChannelApplications = ({ id }) => {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [list, setList] = useState([]);
  const [details, setDetails] = useState({});
  const [openApplicationModal, setOpenApplicationModal] = useState(false);

  const getChannelDetails = async () => {
    try {
      let data = await apiClient.get(`${SSO_URL}${GET_CHANNEL_DETAILS}/${id}`);
      setDetails(data);
    } catch (error) {
      console.log(error);
    }
  };

  const getChannelApplications = async () => {
    try {
      let data = await apiClient.get(`${SSO_URL}${GET_CHANNEL_APPLICATIONS}/${id}`);
      setList(data.filter((item) => item.uuid !== UNO_APPLICATION_ID) || []);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getChannelApplications();
    getChannelDetails();
  }, [id]);

  let filterList = list.filter((item) => item.name.toLowerCase().includes(search.toLowerCase()));

  return (
    <>
      <div className="container-fluid m-0 pt-2 ">
        {/* <div className="col-12">
          <button className="backbtn cursor-pointer mt-2" onClick={() => navigate(-1)} title="Back">
            <BackButton />
            Back
          </button>
        </div>
        <ChannelDetails details={details} /> */}

        <div className="main-list">
          {/* <div className="page-title">
            <h5>Applications</h5>
          </div> */}
          <div className="section  p-4 pt-0">
            <div className="tags-sort my-3">
              <SearchBox search={search} setSearch={setSearch} />
              <button
                className="DefaultRedBtn"
                onClick={() => {
                  setOpenApplicationModal(true);
                }}
              >
                <PlusIcon />
                Add Application
              </button>
            </div>

            <div className="list-view channels">
              <div className="list-here">
                {filterList.map((item, i) => (
                  <div
                    className="channel-card"
                    onClick={() => {
                      if (window.location.pathname.includes("directories"))
                        navigate(`/dashboard/directories/channel/applications/details/${details.uuid}/${item.uuid}`);
                      else navigate(`/dashboard/channels/applications/details/${details.uuid}/${item.uuid}`);
                    }}
                    key={i}
                  >
                    <span className="channel-logo">
                      {item?.icon ? (
                        <img src={item.icon} />
                      ) : (
                        <img src={"https://cdn.simulanis.io/sso/logos/default_simulanis.png"} />
                      )}
                    </span>
                    <span className="channel-detail">
                      <div className="details">
                        <p>{item.name}</p>
                        <p className="des">{item.description}</p>
                      </div>
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <AddDirectoryApplication
        openApplicationModal={openApplicationModal}
        setOpenApplicationModal={setOpenApplicationModal}
        channelData={[{ name: details.name, uuid: details.uuid }]}
        selectChannelDisable={true}
        assignedApplications={list}
        getChannelApplications={getChannelApplications}
      />
    </>
  );
};

export default ChannelApplications;
